import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import { BookSectionView } from '@Selectors/publication/book/view/book-section.view';
import { container } from '@Container';
import { TYPES } from '@Types';
import { Nullable } from '@Models';
import { BookSectionAction } from '@Redux/actions';
import { BookActionState, BookSectionState } from '@Stores/index';
import SectionEditComponent from './edit/section-edit.component';
import SectionCloneComponent from './clone/section-clone.component';
import SectionDeleteComponent from './delete/section-delete.component';
import SectionArmyOrgCommponent
  from './section/section-army-org/section-army-org.component';
import { Col, Row } from 'reactstrap';

interface SectionRowComponentProps {
  section: BookSectionView
}

const SectionRowComponent: React.FC<Props> = ({ section, actions, edit, clone, toDelete, cancel }) => {
  return (
    <div className='army_list_unit army_list_unit_overview box-shadow mt-1 ms-0 me-0' >
      <Row>
        <div className="position ui-sortable-handle">{section.position}</div>
        <Col xs={12} md={9} className='mt-2 mt-xs-0 ps-4 name'>
          <strong>{section.name} </strong>
        </Col>
        {!actions.requested && (
          <Col xs={8} md={3} className="pt-md-2 text-center">
            <a className="m-1" onClick={() => edit(section)}>
              <i className="fa fa-edit fa-2x" />
            </a>
            <a className="m-1" onClick={() => clone(section)}>
              <i className="fa fa-clone fa-2x" />
            </a>
            <a className="m-1" onClick={() => toDelete(section)}>
              <i className="fa fa-trash fa-2x" />
            </a>
          </Col>
        )}
        {actions.requested && (
          <Col xs={8} md={2} className="pt-md-2 text-center">
            <a className="m-1" onClick={() => cancel()}>
              <i className="fa-solid fa-3x fa-rectangle-xmark" />
            </a>
          </Col>
        )}
      </Row>
      <SectionArmyOrgCommponent section={section}/>
      {actions.requestEdit && ( <SectionEditComponent /> )}
      {actions.requestClone && ( <SectionCloneComponent /> )}
      {actions.requestDelete && ( <SectionDeleteComponent /> )}
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: SectionRowComponentProps) => ({
  section: owsProps.section,
  actions: {
    requested: hasAction(state.bookSection, owsProps.section.id),
    requestEdit: hasCurrentAction(
      state.bookSection,
      BookActionState.Edit,
      owsProps.section.id
    ),
    requestClone: hasCurrentAction(
      state.bookSection,
      BookActionState.Clone,
      owsProps.section.id
    ),
    requestDelete: hasCurrentAction(
      state.bookSection,
      BookActionState.Delete,
      owsProps.section.id
    ),
  },
})

const hasAction = (
  bookSectionState: BookSectionState,
  bookSectionId: Nullable<string>
): boolean => {
  return (
    bookSectionState.action !== null &&
    bookSectionId != null &&
    bookSectionId === bookSectionState.id
  );
};

const hasCurrentAction = (
  bookSectionState: BookSectionState,
  key: BookActionState,
  bookSectionId: Nullable<string>
): boolean => {
  return (
    bookSectionState.action === key &&
    bookSectionId != null &&
    bookSectionId === bookSectionState.id
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<BookSectionAction>(
    TYPES.Actions.Publication.BookSectionAction
  );
  return {
    edit: (section: BookSectionView) =>
      dispatch(action.actionRequestEdit(section.item)),
    clone: (section: BookSectionView) =>
      dispatch(action.actionRequestClone(section.item)),
    toDelete: (section: BookSectionView) =>
      dispatch(action.actionRequestDelete(section.item)),
    cancel: () => dispatch(action.cancel()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionRowComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  SectionRowComponentProps
